import {SWRConfig} from "swr"
import {createGlobalFetcher} from "./axios/createGlobalFetcher"
import {useSessionContext} from "./reactContext/contextCustomHooks/useSessionContext"

export default function SwrProviderWithAuth({children}) {
    const {sessionContext, setSessionAction} = useSessionContext()
    const fetcher = createGlobalFetcher(sessionContext.idToken, setSessionAction)
    return (
        <>
        <SWRConfig value={{fetcher}}>
            {children}
        </SWRConfig>
        </>
    )
}